export default "__VITE_ASSET__CrA$58md__"